import type { ICandidate } from "@bbj-types/candidate";
import type { IContact } from "@bbj-types/contact";
import type { IEmail } from "@bbj-types/email";
import type { IEnterprise } from "@bbj-types/enterprise";
import type { IOffer } from "@bbj-types/offer";
import { useCallback } from "react";
import { axiosV2 } from "./axios";

export interface IPostAppliesBatchOfferBody {
  offer: IOffer;
  candidates: ICandidate["_id"][];
  email: IEmail;
  managementProcessId: string;
  status: string;
}

export interface IPostAppliesBatchOffer {
  enterprise: IEnterprise;
  contact: IContact;
}

export const usePostAppliesBatchOffer = () => {
  const [state, execute, cancel] = axiosV2<IPostAppliesBatchOffer | undefined, IPostAppliesBatchOfferBody, unknown>(
    {
      url: "/applys/batch/offer",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostAppliesBatchOfferBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
